@if (isLoading) {
<div
  [class]="`${loadingClass} d-flex justify-content-center align-items-center`"
>
  <!-- <mat-spinner [diameter]="40"></mat-spinner> -->
  <div
    class="d-flex align-self-center justify-content-center align-items-center w-fit spinner-custom w-40px h-40px"
  >
    <app-keenicon
      name="chart"
      class="fs-3qx fw-light text-primary m-n1"
    ></app-keenicon>
  </div>
</div>
}
